import { render, staticRenderFns } from "./page-core-data.vue?vue&type=template&id=74cdf425&scoped=true"
import script from "./page-core-data.vue?vue&type=script&lang=js"
export * from "./page-core-data.vue?vue&type=script&lang=js"
import style0 from "./page-core-data.vue?vue&type=style&index=0&id=74cdf425&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74cdf425",
  null
  
)

export default component.exports